import React from "react";
import biat from "../../files/images/logo_biat.jpg";
import ancom from "../../files/images/logo_ancom.jpg";
import styles from "./partners.module.css";

class Partners extends React.Component {
  render() {
    return (
      <div
        className={styles.container}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "42.3em"
        }}
      >
        <div className={styles.companyContainer} style={{ flex: "12" }}>
          <div>
              <img
                src={biat}
                style={{
                  width: "8.3em",
                  height: "auto"
                }}
                alt="БИАТ"
              />
          </div>
          <div style={{ paddingLeft: "1vw" }}>
            <div style={{ fontWeight: "600", fontSize: "0.92vw" }}>
              ООО Многопрофильный научно-технический центр «БИАТ»
            </div>
            <div style={{ paddingTop: "3vh" }}>
              Организован в январе 1992г на базе отдела Центрального
              научно-исследовательского института комплексной автоматизации
              (ЦНИИКА) и имеет многолетний опыт системной интеграции,
              проектирования, внедрения и сопровождения автоматизированных
              систем управления технологическими процессами в химической,
              нефтехимической, газовой промышленности и автоматизированных
              систем коммерческого и технического учёта энергоносителей в
              энергетике, жилищно-коммунальном хозяйстве и на промышленных
              предприятиях.
            </div>
          </div>
        </div>
        <div style={{ flex: "1" }} />
        <div
          className={styles.companyContainer}
          style={{
            marginTop: "1.5vh",
            flex: "12"
          }}
        >
          <div>
            <a href="http://www.analytic.ru" target="_blank">
              <img src={ancom} style={{ width: "8.3em", height: "auto" }}  alt="ООО «Аналитик ТелекомСистемы»"
/>
            </a>
          </div>
          <div style={{ paddingLeft: "1vw" }}>
            <div style={{ fontWeight: "600", fontSize: "0.92vw" }}>
              ООО «Аналитик ТелекомСистемы»
            </div>
            <div style={{ paddingTop: "3vh" }}>
              Компания создана в 1992 году. Основным направлением деятельности
              является разработка и производство телекоммуникационного
              оборудования, а также средств измерений систем связи под торговой
              маркой AnCom. Приборы получили широкое распространение в различных
              отраслях экономики.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Partners;
